// extracted by mini-css-extract-plugin
export default {"checklistReflection":"ChecklistReflectionSummary__checklistReflection___sm6au","checklistReflectionIcon":"ChecklistReflectionSummary__checklistReflectionIcon___QWooL"};